<template>
  <el-upload
    class="avatar-uploader"
    :action="ssoServerImg"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload">
    <img v-if="imageUrl" :src="imageUrl" class="avatar">
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ssoServerImg: '',
      imageUrl: ''
    }
  },
  mounted() {
    this.ssoServerImg = Vue.prototype.GLOBAL.ssoServerimg
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.imageUrl = newVal;
      }
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data
      this.$emit('input', res.data);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
}

</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/SingleImageUpload.vue